/*----------------------------------
- AGENDA GATEWAY CONTRACT
----------------------------------*/

/**
 * @docs docs/features/agenda
 * @adr  ADR-0073
 */

/**
 * The `/agenda` page reads Product through this Website route (SSR resolves it in process, a
 * client-side navigation posts to it), so every read, from either side, goes through the
 * Website's keyed read cache (`server/lib/agendaPublicRead.ts`).
 */
export const AGENDA_GATEWAY_PATH = '/api/website/agenda/list-public';

/**
 * One industry event's organizer, location and description for the board's modal (ADR-0073):
 * the browser posts `AgendaEventGatewayRequest` here when a visitor opens an event, and the
 * Website answers from its own keyed cache (`agendaEventReadCache`).
 */
export const AGENDA_EVENT_GATEWAY_PATH = '/api/website/agenda/event';

export type AgendaEventGatewayRequest = { id: string };
